module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "modal fade-custom",
    staticStyle: {
      "display": "none",
      "cursor": "pointer"
    },
    attrs: {
      "id": "myModal1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "80%"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "cursor": "initial"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "myCarousel1",
      "data-ride": "carousel1",
      "data-interval": "false",
      "data-wrap": "false"
    }
  }, [_c('div', {
    staticClass: "carousel-inner"
  }, _vm._l((_vm.galleryImages), function(image, index) {
    return _c('div', {
      staticClass: "item",
      class: {
        'active': index == 0
      }
    }, [_c('img', {
      staticStyle: {
        "width": "auto",
        "cursor": "default"
      },
      attrs: {
        "src": image.src
      }
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "glyphicon controller-gallery imageCounter"
  }, [_vm._v(_vm._s(_vm.currentIdx) + "/" + _vm._s(_vm.totalImages))]), _vm._v(" "), _vm._m(2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#myCarousel1",
      "data-slide": "prev"
    }
  }, [_c('div', {
    staticClass: "arrow-left arrow"
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon controller-gallery",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("Prev")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#myCarousel1",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "glyphicon controller-gallery",
    staticStyle: {
      "padding-right": "10px"
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
    staticClass: "arrow-right arrow"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78076f47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = 232
// module chunks = 1